import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Page404 from "./shared/Errors/404";

import PrivateRoute from "./PrivateRoute";
import Login from "../pages/Login";
import Kanban from "../pages/Kanban";
import Project from "../pages/Project";
import Profile from "./Profile/Profile";

const Routes = () => (
  <Router>
    <Switch>
      <Route exact path="/" component={Login} />
      <Route exact path="/login" component={Login} />
      <Route>
        <PrivateRoute Component={Pages} />
      </Route>
    </Switch>
  </Router>
);

const Pages = () => (
  <main>
    <Switch>
      <Route path="/kanban" component={Kanban} />
      <Route path="/:id([0-9a-zA-Z]{20})" component={Project} />
      <Route path="/perfil" component={Profile} />
      <Route>
        <Page404 />
      </Route>
    </Switch>
  </main>
);

export default Routes;
